import { Dialog, DialogProps, ThemeProvider, createTheme } from '@mui/material';
import { theme as appTheme } from '../../theme';
import { OverridesStyleRules } from '@mui/material/styles/overrides';
import clsx from 'clsx';

const paperDialogStyle = appTheme.components?.MuiDialog?.styleOverrides
  ?.paper as OverridesStyleRules;

const theme = createTheme({
  ...appTheme,
  components: {
    ...appTheme.components,
    MuiDialog: {
      ...appTheme.components?.MuiDialog,
      styleOverrides: {
        ...appTheme.components?.MuiDialog?.styleOverrides,
        paper: {
          ...paperDialogStyle,
          backgroundColor: 'transparent',
          boxShadow: 'none',

          '& .MuiPaper-root': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export type ModalProps = DialogProps & {
  children: JSX.Element | JSX.Element[];
  open: boolean;
  className?: string;
  transparentBackground?: boolean;
};

export const Modal = ({
  children,
  open,
  transparentBackground = false,
  ...props
}: ModalProps) => {
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        {...props}
        open={open}
        PaperProps={{
          className: clsx({ 'bg-white shadow-xl': !transparentBackground }),
        }}
      >
        <div className={clsx('w-full h-full flex justify-center items-center')}>
          {children}
        </div>
      </Dialog>
    </ThemeProvider>
  );
};
